const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoManagementQuery: any = {
    CompanyList: Backofficebff + '/v1/cargo/companylist',
    CompanyListV2: Backofficebff + '/v1/cargo/companylist-v2',
    GetCargoCityList: Backofficebff + '/v1/cargo/citylist',
    GetCountyList: Backofficebff + '/v1/cargomanagement/countyList',
    CargoPriorityList: Backofficebff + '/v1/cargomanagement/getcargoprioritylist',
    SubAddressEntities: Backofficebff + '/v1/cargomanagement/subaddressentities',
    CargoCompanyPriorityCity: Backofficebff + '/v1/cargomanagement/getcargocompanyprioritycity',
    CountryAddressRulesforCountryId: Backofficebff + '/v1/cargomanagement/country-address-rulesfor-country-id',
    MobileCountryAddressRule: Backofficebff + '/v1/CargoManagement/mobile-country-address-rule',
    GetPickPoints: Backofficebff + '/v1/CargoManagement/get-pickpoints',
    GetPostalCodeList: Backofficebff + '/v1/cargomanagement/get-postal-code-list',
    GetRegion: Backofficebff + '/v1/cargomanagement/get-region',
    GetStreet: Backofficebff + '/v1/cargomanagement/get-street',
    GetDistrict: Backofficebff + '/v1/cargomanagement/get-district',
};
